import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../StuStyles/StudentProfile.css";
import { TiArrowBack } from "react-icons/ti";
import { useNavigate } from "react-router-dom";
import ApiService from "../../../nhrc_apis/ApiService";

const { StudentProfileAPI } = ApiService;

const StudentProfile = () => {

  const navigate = useNavigate();

  const [personal, setPersonal]         = useState({});
  const [details, setDetails]           = useState({});
  const [documents, setDocuments]       = useState({});
  const [loading, setLoading]           = useState(true);
  const [error, setError]               = useState(null);

  useEffect(() => {
    fetchStudentProfile();
  }, []);

  const fetchStudentProfile = async () => {
    try {
      setLoading(true);
      setError(null);

      const res          = await StudentProfileAPI.getProfile();
      const responseData = res?.data || {};

      console.log("STUDENT PROFILE RESPONSE:", responseData);

      const personalData  = responseData.personal_details  || {};
      const detailsData   = responseData.details           ||
                            responseData.education_details ||
                            responseData.student_details   || {};
      const docsData      = responseData.documents         || {};

      setPersonal(personalData);
      setDetails(detailsData);
      setDocuments(docsData);

    } catch (err) {
      console.error("STUDENT PROFILE ERROR:", err);

      if (err?.response?.status === 401) {
        setError("Session expired. Please login again.");
      } else if (err?.response?.status === 403) {
        setError("Access denied. You do not have permission to view this profile.");
      } else {
        setError(
          err?.response?.data?.detail ||
          "Failed to load student profile. Please try again."
        );
      }
    } finally {
      setLoading(false);
    }
  };

  /* =========================================
     LOADING
  ========================================= */

  if (loading) {
    return (
      <div className="container mt-5 text-center">
        <div className="spinner-border text-primary" role="status"></div>
        <h5 className="mt-3">Loading Student Profile...</h5>
      </div>
    );
  }

  /* =========================================
     ERROR
  ========================================= */

  if (error) {
    return (
      <div className="container mt-5 text-center">
        <div className="alert alert-danger">
          <h5>{error}</h5>
          <button className="btn btn-primary mt-2" onClick={fetchStudentProfile}>
            Retry
          </button>
        </div>
      </div>
    );
  }

  /* =========================================
     RENDER
  ========================================= */

  return (
    <div className="container student-profile-container mt-4 mb-5">

      {/* HEADER */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="fw-bold">STUDENT PROFILE</h4>
      </div>

      {/* BACK BUTTON */}
      <button className="jobback mb-3" onClick={() => navigate(-1)}>
        <TiArrowBack /> Back
      </button>

      {/* =========================================
          PERSONAL DETAILS
      ========================================= */}

      <div className="card p-4 mb-4 shadow-sm">
        <h5 className="section-title text-center mb-4">Personal Details</h5>

        {/* PROFILE PIC */}
        <div className="text-center mb-4">
          <img
            src={
              personal.profile_pic && personal.profile_pic !== "string"
                ? personal.profile_pic
                : "https://dummyimage.com/150x150/cccccc/000000&text=No+Image"
            }
            alt="Profile"
            style={{
              width: "150px",
              height: "150px",
              objectFit: "cover",
              borderRadius: "10px",
              border: "2px solid #dee2e6",
            }}
            onError={(e) => {
              e.target.src =
                "https://dummyimage.com/150x150/cccccc/000000&text=No+Image";
            }}
          />
        </div>

        <div className="row g-3">

          <div className="col-md-4">
            <label className="form-label fw-semibold">Membership ID</label>
            <input className="form-control bg-light" value={personal.membership_id || "—"} readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Full Name</label>
            <input className="form-control bg-light" value={personal.full_name || "—"} readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Email</label>
            <input className="form-control bg-light" value={personal.email || "—"} readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Mobile</label>
            <input className="form-control bg-light" value={personal.mobile || "—"} readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Gender</label>
            <input className="form-control bg-light" value={personal.gender || "—"} readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Date of Birth</label>
            <input className="form-control bg-light" value={personal.dob || "—"} readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Blood Group</label>
            <input className="form-control bg-light" value={personal.blood_group || "—"} readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">State</label>
            <input className="form-control bg-light" value={personal.state || "—"} readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">District</label>
            <input className="form-control bg-light" value={personal.district || "—"} readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Pincode</label>
            <input className="form-control bg-light" value={personal.pincode || "—"} readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Candidate Type</label>
            <input className="form-control bg-light" value={personal.candidate_type || "—"} readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Status</label>
            <input
              className="form-control bg-light"
              value={personal.status || "—"}
              readOnly
              style={{
                color:
                  personal.status === "approved"
                    ? "green"
                    : personal.status === "rejected"
                    ? "red"
                    : "inherit",
                fontWeight: "600",
              }}
            />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Member Since</label>
            <input
              className="form-control bg-light"
              value={
                personal.created_at
                  ? new Date(personal.created_at).toLocaleDateString("en-IN", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })
                  : "—"
              }
              readOnly
            />
          </div>

        </div>
      </div>

      {/* =========================================
          EDUCATION / STUDENT DETAILS
      ========================================= */}

      <div className="card p-4 mb-4 shadow-sm">
        <h5 className="section-title text-center mb-4">Education Details</h5>

        <div className="row g-3">

          <div className="col-md-4">
            <label className="form-label fw-semibold">University Name</label>
            <input className="form-control bg-light" value={details.university_name || "—"} readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">College Name</label>
            <input className="form-control bg-light" value={details.college_name || "—"} readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Qualification</label>
            <input className="form-control bg-light" value={details.qualification || "—"} readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Department</label>
            <input className="form-control bg-light" value={details.department || "—"} readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Year of Study</label>
            <input className="form-control bg-light" value={details.year_of_study || "—"} readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Graduation Year</label>
            <input className="form-control bg-light" value={details.graduation_year || "—"} readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Student ID</label>
            <input className="form-control bg-light" value={details.student_id || "—"} readOnly />
          </div>

          <div className="col-md-4">
            <label className="form-label fw-semibold">Referral ID</label>
            <input className="form-control bg-light" value={details.referral_id || "—"} readOnly />
          </div>

        </div>
      </div>

      {/* =========================================
          DOCUMENTS
      ========================================= */}

      <div className="card p-4 mb-5 shadow-sm">
        <h5 className="section-title text-center mb-4">Documents</h5>

        <div className="row g-4">

          {/* ID CARD FRONT */}
          <div className="col-md-6">
            <label className="form-label fw-semibold">ID Card Front</label>
            {documents.id_card_front && documents.id_card_front !== "" ? (
              <div>
                <input
                  className="form-control bg-light mb-2"
                  value={documents.id_card_front}
                  readOnly
                />
                <img
                  src={"https://nhrc.onrender.com/" + documents.id_card_front}
                  alt="ID Card Front"
                  style={{
                    width: "100%",
                    maxWidth: "300px",
                    height: "180px",
                    objectFit: "cover",
                    borderRadius: "8px",
                    border: "1px solid #dee2e6",
                  }}
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
              </div>
            ) : (
              <div className="form-control bg-light text-muted">
                No document uploaded
              </div>
            )}
          </div>

          {/* ID CARD BACK */}
          <div className="col-md-6">
            <label className="form-label fw-semibold">ID Card Back</label>
            {documents.id_card_back && documents.id_card_back !== "" ? (
              <div>
                <input
                  className="form-control bg-light mb-2"
                  value={documents.id_card_back}
                  readOnly
                />
                <img
                  src={"https://nhrc.onrender.com/" + documents.id_card_back}
                  alt="ID Card Back"
                  style={{
                    width: "100%",
                    maxWidth: "300px",
                    height: "180px",
                    objectFit: "cover",
                    borderRadius: "8px",
                    border: "1px solid #dee2e6",
                  }}
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
              </div>
            ) : (
              <div className="form-control bg-light text-muted">
                No document uploaded
              </div>
            )}
          </div>

        </div>
      </div>

    </div>
  );
};

export default StudentProfile;